/* Foamera — free gift picker (2026-07-16 draft)

   Any single cushion whose configured total is $250+ comes with a free gift;
   the customer picks Pillow Cover (default) or Table Runner at the bottom of
   Review & Confirm. Theme-side only — the app extension is untouched.

   How it rides along:
     - UI mounts as the LAST child of `[data-pcfg-review-section] .pcfg__step-review`.
       The app only rewrites the four data-pcfg-review-* slots' innerHTML, never
       this container, so the picker survives every reprice.
     - The choice reaches the order by wrapping PCfg.Cart.buildProperties.
       cfg-core resolves that function at call time (ATC click, confirm-checkbox
       prewarm, edit rehydrate), so one wrap covers every add path. Gift keys are
       not in _extras_json, so the server's price recompute ignores them.
     - Visibility re-evaluates via a MutationObserver on [data-pcfg-review-price],
       which mutates exactly once per completed reprice (300ms debounce).
   Below $250 the picker renders nothing and the wrapper adds nothing — the
   threshold is re-checked at click time, so hiding and pricing can't disagree. */
(function () {
  'use strict';

  var THRESHOLD = 250; /* store currency major units — same scale as calculatePrice().total */

  var GIFTS = {
    pillow: {
      /* cover only — we ship the COVER, not a filled pillow; never promise otherwise */
      name: 'Pillow Cover',
      dims: '18 × 18 in · zippered',
      listed: '$45',
      property: 'Pillow Cover (18×18 in, surprise colour)',
      img: 'https://cdn.shopify.com/s/files/1/0800/2381/4374/files/hf_20260716_100444_fcc35a59-e15b-4613-9a21-8be5895c4da9.png?v=1784196380&width=120'
    },
    runner: {
      name: 'Table Runner',
      dims: '14 × 72 in · finished edge',
      listed: '$40',
      property: 'Table Runner (14×72 in, surprise colour)',
      img: 'https://cdn.shopify.com/s/files/1/0800/2381/4374/files/hf_20260716_095647_2a5b07d8-2271-4738-84f0-b4045dca02f5.png?v=1784195903&width=120'
    }
  };

  var chosen = 'pillow'; /* the pillow is what ships when no choice is made */

  function currentTotal(state) {
    try {
      var s = state || window.PCfg.Core.getState();
      return window.PCfg.Pricing.calculatePrice(s).total || 0;
    } catch (e) {
      return 0;
    }
  }

  /* ---------- properties ---------- */

  function wrapBuildProperties() {
    var cart = window.PCfg.Cart;
    if (cart._foameraGiftWrapped) return;
    var orig = cart.buildProperties;
    cart.buildProperties = function (state) {
      var p = orig.apply(this, arguments);
      try {
        if (currentTotal(state) >= THRESHOLD) {
          p['Gift'] = GIFTS[chosen].property;
          p['_foamera_gift'] = chosen;
        }
      } catch (e) { /* never break the add flow over a gift */ }
      return p;
    };
    cart._foameraGiftWrapped = true;
  }

  /* ---------- UI ---------- */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function buildOption(key) {
    var g = GIFTS[key];
    var row = el('div', 'fmg-opt');
    row.setAttribute('role', 'radio');
    row.setAttribute('tabindex', '0');
    row.setAttribute('data-fmg-key', key);

    var radio = el('span', 'fmg-radio');
    radio.setAttribute('aria-hidden', 'true');

    var img = document.createElement('img');
    img.className = 'fmg-thumb';
    img.src = g.img;
    img.alt = '';
    img.loading = 'lazy';
    img.width = 44;
    img.height = 44;

    var body = el('div', 'fmg-body');
    body.appendChild(el('span', 'fmg-name', g.name));
    body.appendChild(el('span', 'fmg-dims', g.dims));

    var price = el('span', 'fmg-price');
    var was = el('s', 'fmg-was', g.listed);
    var now = el('strong', 'fmg-now', 'FREE');
    price.appendChild(was);
    price.appendChild(document.createTextNode(' '));
    price.appendChild(now);

    row.appendChild(radio);
    row.appendChild(img);
    row.appendChild(body);
    row.appendChild(price);

    function select() {
      chosen = key;
      syncSelection(row.parentNode);
    }
    row.addEventListener('click', select);
    row.addEventListener('keydown', function (ev) {
      if (ev.key === ' ' || ev.key === 'Enter' || ev.keyCode === 32 || ev.keyCode === 13) {
        ev.preventDefault();
        select();
      }
    });
    return row;
  }

  function syncSelection(group) {
    if (!group) return;
    var rows = group.querySelectorAll('.fmg-opt');
    for (var i = 0; i < rows.length; i++) {
      var on = rows[i].getAttribute('data-fmg-key') === chosen;
      rows[i].className = on ? 'fmg-opt fmg-opt--active' : 'fmg-opt';
      rows[i].setAttribute('aria-checked', on ? 'true' : 'false');
    }
  }

  function buildPicker() {
    var box = el('div', '');
    box.id = 'foamera-gift';
    box.style.display = 'none'; /* evaluate() reveals it — no flash below threshold */

    /* Short, value-led header — "free gift" said ONCE, worth stated up front,
       threshold cut to a fragment (was: three lines each repeating "free"). */
    box.appendChild(el('span', 'fmg-eyebrow', 'Free gift · worth $45'));
    box.appendChild(el('h4', 'fmg-title', 'Choose your gift'));
    box.appendChild(el('p', 'fmg-sub', 'Over $250 · ships in the same box.'));

    var group = el('div', 'fmg-group');
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'Choose your free gift');
    group.appendChild(buildOption('pillow'));
    group.appendChild(buildOption('runner'));
    box.appendChild(group);

    /* "Both are listed in our shop at the prices shown" removed — verified false:
       storefront search has no Table Runner product. Never claim what we don't list. */
    box.appendChild(el('p', 'fmg-note',
      'Colour & pattern are a surprise — no two are alike.'));

    syncSelection(group);
    return box;
  }

  function evaluate() {
    var box = document.getElementById('foamera-gift');
    if (box) box.style.display = currentTotal() >= THRESHOLD ? '' : 'none';
  }

  function observePrice() {
    var node = document.querySelector('[data-pcfg-review-price]');
    if (!node || !window.MutationObserver) return;
    var mo = new MutationObserver(evaluate);
    mo.observe(node, { childList: true, characterData: true, subtree: true });
  }

  function mount() {
    if (document.getElementById('foamera-gift')) { evaluate(); return; }
    var host = document.querySelector('[data-pcfg-review-section] .pcfg__step-review');
    if (!host) return;
    host.appendChild(buildPicker());
    evaluate();
    observePrice();
  }

  /* ---------- boot ---------- */

  function ready() {
    return window.PCfg && window.PCfg.Core && window.PCfg.Pricing &&
      window.PCfg.Cart && window.PCfg.Cart.buildProperties &&
      document.querySelector('[data-pcfg-review-section] .pcfg__step-review');
  }

  function boot() {
    if (!document.getElementById('pcfg-root')) return; /* not a configurator product */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (ready()) {
        clearInterval(iv);
        wrapBuildProperties();
        mount();
      } else if (tries > 40) { /* ~10s — configurator never became ready */
        clearInterval(iv);
      }
    }, 250);
  }

  /* theme editor re-renders replace the section DOM — remount on fresh nodes */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(boot, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
